export default __webpack_public_path__ + "static/media/IMG20230506231648 - ME B6 6121 Aditya Dabral.c4075423.jpg";